import { Button } from "components/DesignSystem/Button/Button";
import { FormikForm } from "components/FormikForm/FormikForm";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";

const ON_HOLD_DEFAULT_DESCRIPTION =
  "Your filing is temporarily on hold while we sort out a few details. No action needed from you right now — we'll let you know as soon as it's moving again.";

export const TaskStateChangeModal = ({
  isOpen,
  onClose,
  onConfirm,
  targetLabel,
  customerLabel,
  isOnHold,
  isLoading,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (description?: string) => void;
  targetLabel: string;
  customerLabel?: string;
  isOnHold: boolean;
  isLoading: boolean;
}) => {
  const handleOpenChange = (open: boolean) => {
    if (!open) onClose();
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Modal.Content>
        {isOnHold ? (
          <FormikForm
            initialValues={{ description: ON_HOLD_DEFAULT_DESCRIPTION }}
            onSubmit={({ description }) => onConfirm(description)}
          >
            <Modal.Header>
              <Modal.Title>Put Filing on Hold</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <TextArea
                label="Specify reason"
                name="description"
                rows={5}
                note={
                  <span className="t-text-orange t-italic">
                    This will be shown to the customer
                  </span>
                }
              />
            </Modal.Body>
            <Modal.Footer>
              <div className="t-flex t-justify-end t-gap-3">
                <Button
                  customType="secondary"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  customType="primary"
                  type="submit"
                  isLoading={isLoading}
                >
                  Confirm status change
                </Button>
              </div>
            </Modal.Footer>
          </FormikForm>
        ) : (
          <>
            <StatusModal
              type="warning"
              title="This change is visible to your customer"
            >
              {customerLabel ? (
                <>
                  This will move the filing to{" "}
                  <span className="t-font-medium">{targetLabel}</span> and
                  update the customer-facing status to{" "}
                  <span className="t-font-medium t-italic">
                    &lsquo;{customerLabel}&rsquo;
                  </span>
                  . Do you want to continue?
                </>
              ) : (
                <>
                  This will update the customer-facing status to{" "}
                  <span className="t-font-medium t-italic">
                    &lsquo;{targetLabel}&rsquo;
                  </span>
                  . Do you want to continue?
                </>
              )}
            </StatusModal>
            <Modal.Footer>
              <div className="t-flex t-justify-end t-gap-3">
                <Button
                  customType="secondary"
                  onClick={onClose}
                  disabled={isLoading}
                >
                  Go back
                </Button>
                <Button
                  customType="primary"
                  onClick={() => onConfirm()}
                  isLoading={isLoading}
                >
                  Yes, move
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal.Content>
    </Modal.Root>
  );
};
